import { Flex, Text } from "@/atoms"
import { NAMES_ROUTES } from "@/const/routes.constants"
import { TEASERS } from "@/const/teaser.constants"
import { useNumberConvertor } from "@/hooks/useNumberConvertor"
import useServices from "@/hooks/useServices"
import { useTranslation } from "@/hooks/useTranslation"
import { SafetyOutlined, WarningOutlined } from "@/icons"
import { IconLabelWidget } from "@/pages/DashboardPage/components/molecules/IconLabelWidget"
import CardDashboardTemplate from "@/pages/DashboardPage/components/templates/CardDashboardTemplate"
import { useGetAdrIncidentsHistory } from "@/pages/TriagePage/application/useAdrIncidents"
import { CardAdrIncidentsWidget } from "./CardAdrIncidentsWidget"

import styles from "./AdrIncidentsWidget.module.scss"

export const AdrIncidentsWidget = () => {
  const { t } = useTranslation()
  const { ROOT, INCIDENTS } = NAMES_ROUTES.TRIAGE
  const { response, isLoading } = useGetAdrIncidentsHistory()
  const { abbreviateNumber } = useNumberConvertor()
  const { auth } = useServices()
  const length = response?.data?.length || 0
  const count = auth.isDemo() ? 15 : length
  const text = abbreviateNumber(count)

  return (
    <CardDashboardTemplate
      title={t("dashboard.adrIncidentsWidget.title")}
      to={`/${ROOT}/${INCIDENTS}`}
      loading={isLoading}
      className={{ row: styles.row }}
      teasers={{
        dataReadiness: true,
        kortexInstalled: TEASERS.KORTEX_INSTALLED.noActiveSensorsDeployed(t)
      }}
    >
      <Flex vertical flex={1} gap={36}>
        <Flex vertical gap={8} justify="center" align="center" flex={1}>
          <IconLabelWidget
            classes={{ color: styles.warning }}
            text={text}
            to={`/${ROOT}/${INCIDENTS}`}
          />
          <Text className={styles.warning}>Live Incidents</Text>
        </Flex>
        <Flex vertical gap={8} flex={1}>
          <CardAdrIncidentsWidget
            icon={<WarningOutlined className={styles.warning} />}
            text="Production"
          />
          <CardAdrIncidentsWidget
            icon={<SafetyOutlined className={styles.success} />}
            text="Demo"
          />
        </Flex>
      </Flex>
    </CardDashboardTemplate>
  )
}
